document.addEventListener('DOMContentLoaded', () => {
  const tabContainers = document.querySelectorAll('[data-product-tabs]');

  tabContainers.forEach((container) => {
    // Prevent the same tab system from being initialized more than once
    if (container.dataset.tabsInitialized === 'true') return;
    container.dataset.tabsInitialized = 'true';

    const buttons = container.querySelectorAll('.product-info-tabs__button');

    // Find the Shopify section containing this tab system
    const section = container.closest('section');

    if (!section) return;

    // Find only the content belonging to this section
    const productContent = section.querySelectorAll(
      '.accordion[data-product], .product-testimonial-tabs__content[data-product]'
    );

    function showTab(product) {
      buttons.forEach((button) => {
        button.classList.toggle(
          'is-active',
          button.dataset.product === product
        );
      });

      productContent.forEach((content) => {
        if (content.dataset.product === product) {
          content.style.display = 'block';
          content.style.opacity = '0';

          requestAnimationFrame(() => {
            content.style.transition = 'opacity .18s ease';
            content.style.opacity = '1';
          });
        } else {
          content.style.display = 'none';
        }
      });
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        showTab(button.dataset.product);
      });
    });

    showTab('tab1');
  });
});